import { BaseService, RequestType, ResponseType } from "@intech/react-service";
import { FuncionarioEntidade, PesquisaDados } from "../entidades";

import { FuncionarioDados } from "../entidades/FuncionarioDados";
import { FuncionarioNPDados } from "../entidades/FuncionarioNPDados";

class Funcionario extends BaseService {

  constructor() {
    super("Funcionario");
  }

  Buscar = () =>
    this.CreateRequest<FuncionarioDados>(RequestType.GET, `/`);

  BuscarNP = () =>
    this.CreateRequest<FuncionarioNPDados>(RequestType.GET, `/`);

  Pesquisar = (dados: PesquisaDados) =>
    this.CreateRequest<Array<FuncionarioEntidade>>(RequestType.POST, "pesquisar", dados);
}

export const FuncionarioService = new Funcionario();